import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const TauriMenuChildren = ({ subMenu, submenuIconStyle, toggleMenu, handleMouseLeave, handleClick, submenuStyle, parent }) => {
const handleGetChild = (subitem, e) => {
        if (!!subitem.children === false && subitem.path) {
            handleClick(!!subitem.children, subitem, parent);
        }
    }

    return (
        <ul className="submenu" style={submenuStyle}>
            {subMenu.map((subItem, index) => (
                <li>
                    {subItem.menuHeader && (
                        <div className="header-content px-3 pt-2">
                            <div className="header-left">{subItem.menuHeader}</div>
                            <div className="header-right"></div>
                        </div>
                    )}
                    <div className='item-list px-3 py-1'>
                        <Link key={index} to={`${subItem.path}/${subItem.id}`} onMouseEnter={toggleMenu} onMouseLeave={handleMouseLeave} onClick={(e) => handleGetChild(subItem, e)}>
                            {subItem.icon && <img src={`${process.env.PUBLIC_URL}${subItem.icon}`} style={submenuIconStyle} alt="Icon"/>}
                            {subItem.name}
                            {subItem.children && <span className="dropdown-icon">&#9658;</span>}
                        </Link>
                        {subItem.children && (
                            <TauriMenuChildren
                                subMenu={subItem.children}
                                submenuIconStyle={submenuIconStyle}
                                toggleMenu={toggleMenu}
                                handleMouseLeave={handleMouseLeave}
                                handleClick={handleClick}
                                submenuStyle={submenuStyle}
                                parent={parent}
                            />
                        )}
                    </div>
                </li>
            ))}
        </ul>
    );
};

export default TauriMenuChildren;
